import { Button } from "antd";
import React, { useState, useEffect } from "react";
import { useMostrarHotkeys } from "./HotKeyContext";

// Inyectar estilos una sola vez al cargar el módulo
if (typeof document !== 'undefined') {
  const styleId = 'button-item-focus-styles';
  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = `
      .button-item-keyboard-focus .ant-btn:focus-visible {
        outline: 3px solid var(--focus-color) !important;
        outline-offset: 3px !important;
        box-shadow: 0 0 0 6px var(--focus-shadow) !important;
        transition: all 0.2s ease !important;
      }

      /* Remover el outline cuando se hace click */
      .button-item-keyboard-focus .ant-btn:focus:not(:focus-visible) {
        outline: none !important;
        box-shadow: none !important;
      }
    `;
    document.head.appendChild(styleElement);
  }
}

const PALETTES = {
  // Existentes
  default: { nombre: "cian", base: "#00b5e2", border: "#00b5e2", text: "#fff", hoverBg: "#fff", hoverText: "#00b5e2" },
  danger: { nombre: "peligro", base: "#ff4d4f", border: "#ff4d4f", text: "#fff", hoverBg: "#fff", hoverText: "#ff4d4f" },
  blanco: { nombre: "blanco", base: "#FFFFFF", border: "#e6e6e6ff", text: "#000", hoverBg: "#f5f5f5", hoverText: "#000" , iconColor: "#000000ff"},
  verde: { nombre: "verde", base: "green", border: "green", text: "#fff", hoverBg: "#f5f5f5", hoverText: "green" },
  naranja: { nombre: "naranja", base: "#fd9e62", border: "#fe995b", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#fe995b"},
  rojo: { nombre: "rojo", base: "#df0101", border: "#e84646", text: "#fff", hoverBg: "#fff", hoverText: "#e84646" },
  morado: { nombre: "morado", base: "#800080", border: "#800080", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#800080" },
  rosa: { nombre: "rosa", base: "#f38cb9", border: "#f38cb9", text: "#f5f5f5", hoverBg: "#f5f5f5", hoverText: "#f38cb9" },
  vino: { nombre: "vino", base: "#8B0000", border: "#8B0000", text: "#fff", hoverBg: "#fff", hoverText: "#8B0000" },

  // 10 NUEVOS
  azul: { nombre: "azul", base: "#1E88E5", border: "#1E88E5", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#1E88E5" },
  azulMarino: { nombre: "azul marino", base: "#0B3D91", border: "#0B3D91", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#0B3D91" },
  celeste: { nombre: "celeste", base: "#81D4FA", border: "#81D4FA", text: "#222", hoverBg: "#f5f5f5", hoverText: "#81D4FA" },
  turquesa: { nombre: "turquesa", base: "#2EC4B6", border: "#2EC4B6", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#2EC4B6" },
  amarillo: { nombre: "amarillo", base: "#ffd91b", border: "#FFEB3B", text: "#333", hoverBg: "#f5f5f5", hoverText: "#FFEB3B",iconColor: "#ffff" },
  ambar: { nombre: "ámbar", base: "#efb300", border: "#FFC107", text: "#333", hoverBg: "#f5f5f5", hoverText: "#FFC107"},
  gris: { nombre: "gris", base: "#9E9E9E", border: "#9E9E9E", text: "#ffffff", hoverBg: "#f5f5f5", hoverText: "#9E9E9E" },
  negro2: { nombre: "negro", base: "#111111", border: "#111111", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#111111" },
  olivo: { nombre: "olivo", base: "#556B2F", border: "#556B2F", text: "#fff", hoverBg: "#f5f5f5", hoverText: "#556B2F" },
  cafe: { nombre: "café", base: "#795548", border: "#795548", text: "#ffff", hoverBg: "#f5f5f5", hoverText: "#795548" },
  bondi: { nombre: "bondi",  base: "#2d929e", border: "#2d929e", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#2d929e" },
  mostaza: { nombre: "mostaza", base: "#f5d107", border: "#f5d107", text: "#5f5550", hoverBg: "#f5f5f5", hoverText: "#f5d107"},

  //Paleta prueba
  cyan: { nombre: "cyan",  base: "#00BFD6", border: "#00BFD6", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#00BFD6" },
  naranja2: { nombre: "naranja", base: "#FF6A0D", border: "#FF6A0D", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#FF6A0D" },
  lima: { nombre: "lima",  base: "#C9DF00", border: "#C9DF00", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#C9DF00" },
  arena: { nombre: "arena",  base: "#BF8D6F", border: "#BF8D6F", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#BF8D6F" },
  petroleo: { nombre: "petroleo", base: "#006b7a", border: "#006b7a", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#006b7a" },
  siena: { nombre: "siena", base: "#672902ff", border: "#672902ff", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#9C3C01" },
  olivaOscuro: { nombre: "oli", base: "#5E6801", border: "#5E6801", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#5E6801" },
  carbon: { nombre: "carbon", base: "#2C272A", border: "#2C272A", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#2C272A" },
  cuero: { nombre: "cuero", base: "#402E32", border: "#402E32", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#402E32" },
  lila: { nombre: "siena", base: "#5e4276ff", border: "#5e4276ff", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#5e4276ff" },
  naranjaOscuro: { nombre: "naranja", base: "#e16b1d", border: "#d4651b", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#ff8e47ff" },
  verdeNatural: { nombre: "verde natural", base: "#24ad44", border: "#24ad44", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#659c0d" },
  AzulC: { nombre: "azul claro", base: "#9bbee1", border: "#68a4e0", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#9bbee1" },
  VerdeC: { nombre: "verde claro", base: "#b8e2b2", border: "#81e172", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#81e172" },

  //Colores inversos
  rojo2: { nombre: "rojo2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#ff4d4f" },
  azulMarino2: { nombre: "azul marino2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#0B3D91" },
  azul2: { nombre: "azul2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#1E88E5" },
  amarillo2: { nombre: "amarillo2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#a66d02ff" },
  cuero2: { nombre: "cuero2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#a84d15ff" },
  lima2: { nombre: "lima2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#C9DF00" },
  cyan2: { nombre: "cyan2", base: "#fff", border: "#fff", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#00BFD6" },
  negro: { nombre: "negro", base: "#fff", border: "#c0c0c0", text: "#000000", hoverBg: "#f5f5f5", hoverText: "#000000" },
  lila2: { nombre: "lila2", base: "#fff", border: "#fff", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#fff", iconColor: "#8155a9ff" },
  naranja3: { nombre: "naranja", base: "#fff", border: "#fff", text: "#ffffff",  hoverBg: "#f5f5f5", hoverText: "#fff" , iconColor: "#ff8e47ff" },
  verde2: { nombre: "verde", base: "green", border: "green", text: "#fff", hoverBg: "#f5f5f5", hoverText: "green" },

  // Existentes inversos de FORMS
  naranjaB: { nombre: "naranja", base: "#fff", border: "#fff", text: "#ff8e47ff",  hoverBg: "#ff8e47ff", hoverText: "#ffffffff" , iconColor: "#ff8e47ff" },
  rojoB: { nombre: "rojo", base: "#fff", border: "#e84646", text: "#e84646", hoverBg: "#e84646", hoverText: "#ffffffff",iconColor: "#ff8e47ff"  },
  moradoB: { nombre: "morado", base: "#ffff", border: "#800080", text: "#800080", hoverBg: "#800080", hoverText: "#ffffffff",iconColor: "#800080"  },
  rosaB: { nombre: "rosa",base: "#ffff", border: "#FF69E1", text: "#FF69E1", hoverBg: "#FF69E1", hoverText: "#ffffffff",iconColor: "#FF69E1"  },
  arenaB: { nombre: "arena",base: "#fff", border: "#BF8D6F", text: "#BF8D6F",  hoverBg: "#BF8D6F", hoverText: "#ffffffff",iconColor: "#BF8D6F" },
  lilaB: { nombre: "siena", base: "#fff", border: "#664781ff", text: "#664781ff",  hoverBg: "#664781ff", hoverText: "#ffffffff",iconColor: "#664781ff" },
  cyanB: { nombre: "cyan2", base: "#fff", border: "#00BFD6", text: "#00BFD6", hoverBg: "#00BFD6", hoverText: "#ffffffff", iconColor: "#00BFD6" },
  azulMB: { nombre: "azul marino", base: "#fff", border: "#0e439fff", text: "#0e439fff", hoverBg: "#0e439fff", hoverText: "#ffffffff",iconColor: "#0e439fff"},
  cafeB: { nombre: "café", base: "#fff", border: "#7d5546ff", text: "#7d5546ff", hoverBg: "#7d5546ff", hoverText: "#ffffffff", iconColor:"#7d5546ff" },
  verdeB: { nombre: "verde", base: "#fff", border: "green", text: "green", hoverBg: "green", hoverText: "#ffffffff", iconColor:"green"},
  limaB: { nombre: "lima", base: "#fff", border: "#fff", text: "#C9DF00", hoverBg: "#C9DF00", hoverText: "#fff", iconColor: "#C9DF00" },
  ambarB: { nombre: "ámbar", base: "#fff", border: "#FFC107", text: "#FFC107", hoverBg: "#FFC107", hoverText: "#ffffffff", iconColor: "#FFC107" },
  negroB: { nombre: "negro", base: "#fff", border: "#000000", text: "#000000", hoverBg: "#000000", hoverText: "#ffffffff", iconColor: "#000000" },
};

/*
  Formatea la hotkey para mostrar en el badge.
  "alt+a" → "Alt + A", "ctrl+enter" → "Ctrl + Enter", "insert" → "Insert"
*/
 const formatHotkeyLabel = (hotkey) => {
 if (!hotkey) return '';
 return hotkey
     .split('+')
 .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' + ');
 };


// Componente hoja que consume el contexto de hotkeys, para que ButtonItem
// no se re-renderice completo cada vez que se presiona/suelta Shift.
const HotkeyBadge = ({ hotkey }) => {
  const mostrarHotkeys = useMostrarHotkeys();
  if (!hotkey || !mostrarHotkeys) return null;
  return <span className="hotkey-badge">{formatHotkeyLabel(hotkey)}</span>;
};

const ButtonItem = ({ children, style: rawStyle, onClick, htmlType, icon, botonAncho, className, ...props }) => {
  const {
    width: styleWidth,
    display: styleDisplay,
    margin: styleMargin,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    ...buttonOnlyStyle
  } = rawStyle || {};

  // Los márgenes van al wrapper SOLO cuando hay un width explícito (ej: width:"30%", marginLeft:"35%")
  // Si no hay width explícito, los márgenes quedan en el botón para que funcione el patrón
  // display:block + margin:0 0 0 auto (alinear a la derecha)
  const hasExplicitWidth = !!styleWidth;

  // const wrapperMargins = hasExplicitWidth ? {
  //   margin: styleMargin,
  //   marginLeft,
  //   marginRight,
  //   marginTop,
  //   marginBottom,
  // } : {};

  const buttonMargins = hasExplicitWidth ? {} : {
    ...(styleMargin !== undefined && { margin: styleMargin }),
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginRight !== undefined && { marginRight }),
    ...(marginTop !== undefined && { marginTop }),
    ...(marginBottom !== undefined && { marginBottom }),
  };

  const style = {
    ...buttonOnlyStyle,
    ...buttonMargins,
    ...(styleDisplay && { display: styleDisplay }),
  };
  const [isHovered, setIsHovered] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const timeoutRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  // Ref con estado actual para el hotkey handler (evita closures obsoletos)
  const hotkeyStateRef = React.useRef({}); //aquí se guarda el estado actual

  useEffect(() => { // Resetear estado ocupado y deshabilitado si cambia resetKey
    if (props.resetKey && props.disableWhenClick) {
      setDisableButton(false);
    }
  }, [props.resetKey, props.disableWhenClick]);

    useEffect(() => {
    //limpiar cuando el componente se desmonta
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Hotkey global: acepta formato "insert", "alt+a", "ctrl+enter", etc.
  useEffect(() => {
    if (!props.hotkey) return;

    const parts = props.hotkey.toLowerCase().split('+');
    const needsCtrl = parts.includes('ctrl');
    const needsAlt = parts.includes('alt');
    const needsShift = parts.includes('shift');
    const targetKey = parts[parts.length - 1];

    const handler = (e) => {
      const { isDisabled, click } = hotkeyStateRef.current;
      if (isDisabled) return;

      // No disparar cuando el foco está en un elemento editable.
      // Ant Design Select puede dejar el foco en un div interno (.ant-select-selector),
      // no en un INPUT, por eso se revisa también el ancestro .ant-select.
      const active = document.activeElement; //elemento actualmente enfocado
      if (
        active &&
        (active.tagName === 'INPUT' ||
          active.tagName === 'TEXTAREA' ||
          active.tagName === 'SELECT' ||
          active.isContentEditable ||
          !!active.closest('.ant-select'))
      ) return;

      // e.key en Mac con Alt genera caracteres especiales (ej: Alt+A → "å")
      // e.code es la tecla física y no cambia con modificadores: "KeyA", "Enter", etc.
      const keyMatch =
        e.key.toLowerCase() === targetKey ||          // teclas especiales: "enter", "insert", "f2"
        e.code.toLowerCase() === `key${targetKey}` || // letras con Alt en Mac: "keya" === "keya"
        e.code.toLowerCase() === targetKey;            // fallback: "enter" === "enter"
      if (!keyMatch) return;
      if (e.ctrlKey !== needsCtrl || e.altKey !== needsAlt || e.shiftKey !== needsShift) return;
      // Para botones submit: clic programático para que el form se envíe normalmente
      if (hotkeyStateRef.current.isSubmit) {
        buttonRef.current?.click();
        return;
      }
      e.preventDefault();
      click(e);
    };

    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [props.hotkey]);

  // Actualizar ref en cada render para que el hotkey handler siempre use estado fresco
  hotkeyStateRef.current = {
    isDisabled: props.disabled || isBusy || disableButton,
    isSubmit: htmlType === "submit",
    click: null, // se completa abajo, después de definir handleClick
  };

  const handleClick = (e) => {
    if (htmlType === "submit") {
      if (onClick) {
        onClick(e);
      }
      return;
    }

    if (isBusy) return;
    setIsBusy(true);
    if (props.disableWhenClick) setDisableButton(true);

    try {
      onClick?.(e); // Ejecuta lógica sincrónica o no esperada
    } catch (err) {
      console.error("Error al ejecutar onClick", err);
    }
    
    // Limpiar timeout previo si existe
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Siempre libera después de un tiempo fijo
    timeoutRef.current = setTimeout(() => {
      setIsBusy(false);
      timeoutRef.current = null;
    }, props.lessTime ? 100 : 1000);

    // Siempre libera después de un tiempo fijo
    setTimeout(() => setIsBusy(false), props.lessTime ? 100 : 1000); // Cambia 1500 por el tiempo deseado
  };
   // Apuntar la ref al handleClick ya definido
   hotkeyStateRef.current.click = handleClick;

  // Detecta qué color usar según las props booleanas
  const getColorKey = () => {
    // prioridad: si alguna prop coincide con una clave de PALETTES, úsala
    const keys = Object.keys(PALETTES);
    for (const k of keys) {
      if (props[k]) return k;
    }
    // compat alias: si usan 'rojo'/'danger' ambos apuntan a su paleta
    if (props.rojo) return "rojo";
    if (props.danger) return "danger";
    return "default";
  };

  const palette = PALETTES[getColorKey()];

  // Obtener color para el outline cuando se usa TAB
  const getFocusOutlineColor = () => {
    if (props.disabled || isBusy || disableButton) {
      return "#d9d9d9";
    }
    // Si el fondo es blanco, usar el color del ícono o del borde para que sea visible
    if (palette.base === "#fff" || palette.base === "#FFFFFF" || palette.base === "#ffff") {
      return palette.iconColor || palette.border || palette.text || "#1890ff";
    }
    return palette.base || "#1890ff";
  };

  const focusColor = getFocusOutlineColor();
  const focusShadow = `${focusColor}40`;

  const baseStyle = {
    borderRadius: "6px",
    padding: "0 6px",
    fontSize: "14px",
    fontWeight: "500",
    transition: "background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: props.size === "small" ? "30px" : "25px",
    border: "2px solid",
    cursor: props.disabled || isBusy || disableButton ? "not-allowed" : "pointer",
    // Si el wrapper tiene ancho explícito, el botón debe llenarlo
    ...(styleWidth ? { width: "100%" } : {}),
    ...style,
  };

  const disabledBg = "#f5f5f5";
  const disabledBorder = "#f5f5f5";
  const disabledText = "#c0c0c0";

  const mergedStyle = {
    ...baseStyle,
    backgroundColor:
      props.disabled || isBusy || disableButton
        ? disabledBg
        : isHovered
          ? palette.hoverBg
          : palette.base,
    borderColor:
      props.disabled || isBusy || disableButton
        ? disabledBorder
        : palette.border,
    color:
      props.disabled || isBusy || disableButton
        ? disabledText
        : isHovered
          ? palette.hoverText
          : palette.text,
  };
  
   // Clonar el ícono con el color personalizado si se especifica
  const getIconColor = () => {
    // Si hay un iconColor en las props, tiene prioridad
    if (props.iconColor) {
      // Si iconColor es un string que coincide con una paleta, usar el color base de esa paleta
      if (typeof props.iconColor === 'string' && PALETTES[props.iconColor]) {
        return PALETTES[props.iconColor].base;
      }
      // Si no, asumir que es un color directo (hex, rgb, nombre de color CSS)
      return props.iconColor;
    }

    // Si no hay iconColor en props, verificar si la paleta actual tiene iconColor definido
    if (palette.iconColor) {
      return palette.iconColor;
    }

    return null;
  };

  // botonAncho: atajo para aplicar el estilo de "botonAgregar" (padding/alto estándar) sin repetir className
  const mergedClassName = [className, botonAncho && "botonAgregar"].filter(Boolean).join(" ");

  const iconColor = getIconColor();
  const customIcon = icon && iconColor
    ? React.cloneElement(icon, {
        style: {
          ...icon.props?.style,
          color: iconColor
        }
      })
    : icon;
    
  return (
    <>
      <div
        className="button-item-keyboard-focus"
        style={{
          '--focus-color': focusColor,
          '--focus-shadow': focusShadow,
          position: 'relative',
          width: styleWidth || (styleDisplay === 'block' || props.block ? '100%' : 'fit-content'),
          margin: styleMargin,
          marginLeft,
          marginRight,
          marginTop,
          marginBottom,
          display: (!styleWidth || styleWidth === '100%') && (styleDisplay === 'block' || props.block) ? 'block' : 'inline-block',
        }}
      >
      <HotkeyBadge hotkey={props.hotkey} />
      <Button
         ref={buttonRef}
          {...props}
          icon={customIcon}
          htmlType={htmlType}
          className={mergedClassName || undefined}
          onClick={handleClick}
          style={mergedStyle}
          loading={props.loading || isBusy || disableButton}
          disabled={props.disabled || isBusy || disableButton}
          onMouseEnter={() => {
            setIsHovered(true);
            props.onMouseEnter?.();
          }}
          onMouseLeave={() => {
            setIsHovered(false);
            props.onMouseLeave?.();
          }}
          onKeyDown={(e) => {
          // Enter activa el botón al tenerlo enfocado (igual que Space)
          if (e.key === 'Enter' && !props.disabled && !isBusy && !disableButton) {
            e.preventDefault();
            handleClick(e);
          }
          props.onKeyDown?.(e);
        }}
      
        >
          {children}
        </Button>
      </div>
    </>
  );
};

export { PALETTES };
export default ButtonItem;
